import { Component } from '@angular/core';
import { ApiRoleService } from "@modules/private/admin/data/services/api/api-role.service";
import { RoleService } from "@modules/private/admin/data/services/view/role.service";
import { ROLE_COLUMNS } from '../../data/constants/role.constants';

@Component({
  selector: 'app-admin-roles',
  templateUrl: './admin-roles.component.html',
  styleUrls: ['./admin-roles.component.scss']
})
export class AdminRolesComponent {
  columns = ROLE_COLUMNS
  createEntity = false
  additionalMainActions = [
    { label: 'Nuevo role', icon: 'fa-solid fa-square-plus', action: 'CREATE' }
  ]
  constructor(
    public apiRoleService: ApiRoleService,
    public roleService: RoleService
  ) {
  }

  hideDialog() {
    this.createEntity = false;
  }

  mainActions(flow: string) {
    switch (flow) {
      case 'CREATE':
        this.roleService.newEntity()
        this.createEntity = true
        break;
      default:
        console.log(flow)
        break;
    }
  }

  saveForm() {

  }
}
